import * as yup from 'yup';

export const createExternalSourceSchema = yup.object().shape({
    name: yup.string().required(),
    price: yup.number().required(),
    duration: yup.object().required(),
    currency: yup.object().required(),
});
